import PropTypes from 'prop-types'
import React from 'react'

const Token = ({ name }) => (
  <>{ name ? name.value : '' }</>
)

Token.propTypes = {
  name: PropTypes.object
}

export default Token
